import { render, staticRenderFns } from "./manage-messaging-services-page.vue?vue&type=template&id=7a6002a3&scoped=true"
import script from "./manage-messaging-services-page.vue?vue&type=script&lang=js"
export * from "./manage-messaging-services-page.vue?vue&type=script&lang=js"
import style0 from "./manage-messaging-services-page.vue?vue&type=style&index=0&id=7a6002a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6002a3",
  null
  
)

export default component.exports